<template>
  <div>
    <b-modal
      class="mc-modal"
      id="modal-shortcut-finish-status"
      ref="mc-modal-change-status"
      :title="$t('maintenance.serviceToNormal')"
      size="lg"
      centered
      scrollable
    >
      <div class="card-body p-2">
        <p>
          {{ $t('maintenance.changeStatusWarning', { data: selectedDataLength }) }}
        </p>
      </div>

      <template #modal-footer="{ cancel }">
        <div class="d-flex">
          <McButton
            variant="secondary"
            class="me-2"
            :text="$t('global.cancel')"
            @click="cancel()"
          />
          <McButton
            variant="primary"
            :text="$t('maintenance.serviceToNormal')"
            @click="handleFinishStatus"
          />
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import McButton from '@/components/McButton'
import { mapGetters } from 'vuex'
import { BULK_UPDATE_SERVICE_SCHEDULE } from '@/services/api/maintenance/serviceSchedules'

export default {
  components: {
    McButton,
  },

  props: {
    selectedDataLength: {},
    selectedIds: {},
    selectedItems: {},
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),
    hasMO() {
      return this.hasAccess([
        'service_order:read',
        'service_order:update',
        'service_order:create',
        'service_order:delete',
      ])
    },
  },

  methods: {
    async handleFinishStatus() {
      const serviceSchedules = this.selectedItems.map((item) => {
        return {
          serviceId: item.serviceId,
          type: item.type,
          vehicleId: item.vehicleId,
        }
      })

      const input = {
        forceInProgress: false,
        serviceSchedules: serviceSchedules,
      }

      await this.$apollo
        .mutate({
          mutation: BULK_UPDATE_SERVICE_SCHEDULE,
          variables: {
            input: input,
          },
        })
        .then((res) => {
          if (res.data.updateServiceSchedules.isSuccessful)
            this.$mcToast.success(this.$t('maintenance.alert.successFinished'))
          else if (res.data.updateServiceSchedules.errorCode === 'E-SS1-U2/3')
            this.$mcToast.error(this.$t('maintenance.alert.editUnabled'))
          else if (res.data.updateServiceSchedules.errorCode === 'E-SS1-U2/4')
            this.$mcToast.error(this.$t('maintenance.alert.failedFinishMO'))
          else this.$mcToast.error(res.data.updateServiceSchedules.message)
        })

      this.$bvModal.hide('modal-shortcut-finish-status')
      this.$emit('refreshPage')
    },
  },
}
</script>
